"use client";

import React from "react";

import { ShowWithComedian } from "@punchup/data/legacy";
import WaitlistInlineForm from "./WaitlistInlineForm";
import WaitlistLoginModal from "./WaitlistLoginModal";
import WaitlistModalBase from "./WaitlistModalBase";
import { useUser } from "@punchup/data/legacy/hooks";

interface WaitlistProps {
  show: ShowWithComedian;
  ownerId: string;
  isVenue?: boolean;
  onClose?: () => void;
  comedianSlug?: string;
  venueSlug?: string;
}

const JoinIcon = () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="18" cy="18" r="18" fill="#FE5E25" />
    <path
      d="M10.6675 26.9144C10.8075 26.9723 10.9537 27 11.1 27V26.9988C11.3775 26.9988 11.6513 26.8975 11.86 26.7047L14.7737 24.0179H25.12C26.7075 24.0179 28 22.7716 28 21.2408V20.3054H18.7939C18.5283 20.3054 18.313 20.0956 18.313 19.8368V19.7029C18.313 19.4441 18.5283 19.2343 18.7939 19.2343H28V17.5607H18.7939C18.5283 17.5607 18.313 17.3509 18.313 17.0921V16.9582C18.313 16.6993 18.5283 16.4895 18.7939 16.4895H28V14.8159H18.7939C18.5283 14.8159 18.313 14.6061 18.313 14.3473V14.2134C18.313 13.9546 18.5283 13.7448 18.7939 13.7448H27.9998C27.9817 12.2276 26.6963 11 25.12 11H12.88C11.2913 11 10 12.2451 10 13.7772V25.9393C10 26.3648 10.2613 26.7469 10.6675 26.9144Z"
      fill="white"
    />
  </svg>
);

const WaitlistModal: React.FC<WaitlistProps> = ({
  show,
  ownerId,
  isVenue,
  onClose,
  comedianSlug,
  venueSlug,
}) => {
  const user = useUser();
  const isAuthenticated = !!user;

  if (!isAuthenticated) {
    return (
      <WaitlistLoginModal
        isOpen={true}
        setIsOpen={(isOpen) => {
          if (!isOpen) onClose?.();
        }}
        show={show}
        ownerId={ownerId}
        isVenue={isVenue}
        onJoinSuccess={onClose}
        comedianSlug={comedianSlug}
        venueSlug={venueSlug}
      />
    );
  }

  return (
    <WaitlistModalBase
      show={show}
      onClose={onClose || (() => {})}
      badgeIcon={<JoinIcon />}
    >
      <WaitlistInlineForm
        show={show}
        ownerId={ownerId}
        isVenue={isVenue}
        comedianSlug={comedianSlug}
        venueSlug={venueSlug}
        onSuccess={onClose}
        onCancel={onClose}
      />
    </WaitlistModalBase>
  );
};

export default WaitlistModal;
